import React from 'react'

export const ChatIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'>
      <g id='chat-rectangle'>
        <path
          id='Path'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.5 1.00049H2.5C1.948 1.00049 1.5 1.44849 1.5 2.00049V10.0005C1.5 10.5525 1.948 11.0005 2.5 11.0005H5.5V15.0005L10.167 11.0005H15.5C16.052 11.0005 16.5 10.5525 16.5 10.0005V2.00049C16.5 1.44849 16.052 1.00049 15.5 1.00049Z'
          stroke='#3B4768'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
